/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description messagedView module
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { default as rootReducer } from './reducers/index'

export default filterActions(rootReducer, Object.values(constants))
